import { useLocation } from '@gatsbyjs/reach-router'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

const Social = () => {
  const location = useLocation()
  const [url, setUrl] = useState<string>('')
  // Location is only available in the browser and we need to force this
  useEffect(() => {
    if (location.href) {
      setUrl(location.href)
    }
  }, [location.href])
  if (!url) {
    return null
  }

  const encodedUrl = encodeURIComponent(url)

  return (
    <Container>
      <a
        href={`https://twitter.com/intent/tweet/?text=${encodedUrl}\n`}
        aria-label="Share on X"
        className="button big social-twitter"
        target="_blank"
        rel="noopener noreferrer"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.7142 10.6226L20.4162 3H18.8286L13.0068 9.61726L8.3604 3H3L10.0278 13.0074L3 20.9999H4.5876L10.7316 14.0104L15.6396 20.9999H21M5.1606 4.17142H7.5996L18.8274 19.8861H16.3878"
            fill="currentColor"
          />
        </svg>
        Share on X
      </a>
      <a
        href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`}
        aria-label="Share on LinkedIn"
        className="button big social-linkedin"
        target="_blank"
        rel="noreferrer"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.25 0.75H18.75C21.2353 0.75 23.25 2.76472 23.25 5.25V18.75C23.25 21.2353 21.2353 23.25 18.75 23.25H5.25C2.76472 23.25 0.75 21.2353 0.75 18.75V5.25C0.75 2.76472 2.76472 0.75 5.25 0.75ZM9.14754 17.25V9.41574H6.93443V17.25H9.14754ZM8.04098 8.51266C7.32836 8.51266 6.75 7.95002 6.75 7.25633C6.75 6.56264 7.32836 6 8.04098 6C8.75361 6 9.33197 6.56264 9.33197 7.25633C9.33197 7.95002 8.75434 8.51266 8.04098 8.51266ZM15.7869 17.25H18V12.4362C18 8.69499 13.8659 8.83102 12.8361 10.6728V9.41574H10.623V17.25H12.8361V13.2588C12.8361 11.0417 15.7869 10.8601 15.7869 13.2588V17.25Z"
            fill="currentColor"
          />
        </svg>
        Share on LinkedIn
      </a>
    </Container>
  )
}

export default Social

const Container = styled.div`
  margin: 24px 0 12px 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.75rem;

  .button {
    display: flex;
    align-items: center;

    svg {
      width: 24px;
      height: 24px;
      margin-right: 0.5rem;
    }
  }

  @media (max-width: 600px) {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
`
